import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { listWorkflowDetailsQuery } from '@shared/services/gql.service';

import {
  QuarterCloseChecklistRowPermissionFields,
  QuarterCloseChecklistRowSections,
  QuarterCloseChecklistRowTitles,
} from './workflow-types';

export interface EDCProperties {
  edc_data_status?: string;
  edc_data_status_update_date?: string;
  edc_data_status_updated_by?: string;
  last_customer_notified_by?: string;
  last_customer_notified_date?: string;
}

export interface Workflow extends Omit<listWorkflowDetailsQuery, 'properties'> {
  last_update_date: string;
  last_updated_by: string;
  last_updated_by_full_name: string;
  permissionField: QuarterCloseChecklistRowPermissionFields;
  properties: WorkflowProperty;
  section: QuarterCloseChecklistRowSections;
  updatedAuthorFullName: string;
  workflowName: QuarterCloseChecklistRowTitles;
}

export type WorkflowModel = getEntityType<WorkflowState>;

export interface WorkflowProperty {
  assigned_by: string;
  assigned_date: string;
  assigned_to: string;
  edc_data_status?: string;
  edc_data_status_update_date?: string;
  edc_data_status_updated_by?: string;
  last_customer_notified_by?: string;
  last_customer_notified_date?: string;
  last_update_info?: {
    ts: string;
    update_date: null | string;
    updated_by: null | string;
  };
  locked: boolean;
  month: string;
  route: string;
}

export type WorkflowState = EntityState<Workflow>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'workflow' })
export class WorkflowStore extends EntityStore<WorkflowState> {
  constructor() {
    super({});
  }
}
